import {mapActions, mapGetters} from 'vuex';
import {seo} from '@/mixins/seo'
import moment from "moment";

import camelCase from "lodash/camelCase";

export default {
    name: 'profile-certificates',
    mixins: [seo],
    data() {
        return {}
    },
    created() {
        this.seo.title = this.$t(camelCase(this.$route.name));
        this.fetchCertificates();
    },
    computed: {
        ...mapGetters({
            certificates: `userSertificates/list`,
            isListLoading: `userSertificates/isListLoading`
        }),
    },
    methods: {
        ...mapActions({
            fetchCertificates: 'userSertificates/GET_LIST'
        }),

        getItemDate(item) {
            let arr = item.createdAt.split(' ')
            return moment(arr[0]).format('DD.MM.YYYY')
        },

        getItemTime(item) {
            let arr = item.createdAt.split(' ')
            return arr[1].slice(0, 5);
        },
    }
}
